module.exports = __webpack_public_path__ + "booksapple.svg?a195ccc908fefb618a7561180922a672";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/booksapple.svg
// module id = 144
// module chunks = 0